module.exports = __webpack_public_path__ + "img/OurStory_Img3.da43ccf3.png";